import { createAction } from '@ngrx/store';

import { httpError, payload } from 'ish-core/utils/ngrx-creators';

import { CustomDotCmsPage, CustomDotCmsPageAsset } from '../../models/page/custom-dot-cms-page.model';
import { DotCmsPageRequestParameters } from '../../services/dot-cms-resource/dot-cms-resource.service';

export const loadDotCmsPage = createAction(
  '[DOTCMS Page Internal] load dotcms page',
  payload<{
    pageURI: string;
    params?: DotCmsPageRequestParameters;
  }>()
);

export const loadDotCmsPageSuccess = createAction(
  '[DOTCMS Page API] load dotcms page Success',
  payload<{
    page: CustomDotCmsPage;
  }>()
);

export const loadDotCmsPageFail = createAction('[DOTCMS API] load dotcms page Fail', httpError());

export const resetDotCmsPageData = createAction('[DOTCMS Internal] clear dotCMS page data');

export const loadUVEDotCmsPageData = createAction(
  '[DOTCMS Page Internal]  dotCMS page data from UVE',
  payload<{
    page: CustomDotCmsPageAsset;
  }>()
);
